(function() {
    'use strict';

    angular.module('competence', [
            'ui.router',
            'competence.constants',
            'competence.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'competencePermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, competencePermissionsConst) {
        $stateProvider
            .state('layout.competence', {
                abstract: true,
                url: '/competencies',
                data: {
                    title: 'Kompetencje',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.competence.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/competence/views/competence-list/competence-list.html',
                        controller: 'CompetenceListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: competencePermissionsConst.view
                }
            })
            .state('layout.competence.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/competence/views/competence-create/competence-create.html',
                        controller: 'CompetenceCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: competencePermissionsConst.add
                }
            })
            .state('layout.competence.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/competence/views/competence-update/competence-update.html',
                        controller: 'CompetenceUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: competencePermissionsConst.update
                }
            });
    }
})();
